import { CoverageDetailsProps } from "../../../../@types/components/enrollmentProps.types";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import { useMemo, useRef, useState } from "react";
import { useCallback } from "react";
import { useContext, useEffect } from "react";
import { numberToDollarStr } from "../../../../utils/commonFunctions/dollar";
import { PaycheckContext, ThemeContext } from "../../../../contexts";
import { useLocation } from "react-router-dom";
import { GROUP_NUMBER } from "../../../../constants/groups";

const CoverageDetails = ({
	coverageDetails,
	titleHeader = "Plans",
	choosePlanText = "Choose your desired plan"
}: CoverageDetailsProps & { titleHeader?: string; choosePlanText?: string }): JSX.Element => {
	const [gridHeight, setGridHeight] = useState("300px");
	const agGridRef = useRef<any>(null);
	const { theme } = useContext(ThemeContext);
	const { paycheck } = useContext(PaycheckContext);
	const location = useLocation();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const handleAgGridReady = (params: GridReadyEvent) => {
		params.api.sizeColumnsToFit();
	};

	const group_number = urlSearchParams.get("gn");
	const premiumValueCellRenderer = useCallback(
		(value: any) => {
			return group_number && (group_number as any as number) == GROUP_NUMBER.PANHANDLE_FIRST_BANK
				? `$${value.data.premiumAmount} of ${paycheck?.pay_frequency} Base Pay`
				: `${value.data.premiumAmount} of ${paycheck?.pay_frequency} Base Pay`;
		},
		[paycheck?.pay_frequency]
	);

	useEffect(() => {
		switch (coverageDetails.length) {
			case 0: {
				setGridHeight("110px");
				break;
			}
			case 1: {
				setGridHeight("110px");
				break;
			}
			case 2: {
				setGridHeight("160px");
				break;
			}
			case 3: {
				setGridHeight("200px");
				break;
			}
			case 4: {
				setGridHeight("240px");
				break;
			}
			case 5: {
				setGridHeight("280px");
				break;
			}
		}
	}, [coverageDetails.length]);

	if (paycheck === null) {
		return <></>;
	}

	return (
		<div className="plan-coverage-details">
			<div className="header-container">
				<div className="theme-plan-header">{titleHeader}</div>
				<div className="theme-plan-sub-header" style={{ borderLeftColor: theme.primary_color }}>
					{choosePlanText}
				</div>
			</div>
			<div className="theme-plan-inner-section-margin" />
			<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
				<AgGridReact
					ref={agGridRef}
					rowData={coverageDetails}
					onGridReady={handleAgGridReady}
					animateRows
					rowDragManaged
					defaultColGroupDef={{ marryChildren: true }}
					rowSelection="single"
					enableCellChangeFlash={true}
					frameworkComponents={{
						premiumValueCellRenderer
					}}
				>
					<AgGridColumn field="coverage" headerName="Coverage"></AgGridColumn>
					<AgGridColumn
						field="premiumAmount"
						headerName="Premium Value"
						cellRenderer="premiumValueCellRenderer"
					></AgGridColumn>
				</AgGridReact>
			</div>
		</div>
	);
};

export default CoverageDetails;
